(function () {
  const drawer = document.getElementById('cart-drawer');
  const cartIcon = document.getElementById('cart-icon');
  const countEl = document.getElementById('cart-icon-count');

  if (!drawer) return;

  function openDrawer() {
    drawer.classList.add('cart-drawer--open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('cart-drawer--open');
    document.body.style.overflow = '';
  }

  drawer.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-drawer-close]')) closeDrawer();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  if (cartIcon) {
    cartIcon.addEventListener('click', function (event) {
      event.preventDefault();
      openDrawer();
    });
  }

  function updateCount(count) {
    if (!countEl) return;
    countEl.textContent = count;
    countEl.hidden = count === 0;
  }

  async function refreshDrawer() {
    const response = await fetch(window.location.pathname + '?sections=cart-drawer');
    const data = await response.json();
    const temp = document.createElement('div');
    temp.innerHTML = data['cart-drawer'];
    const newDrawer = temp.querySelector('#cart-drawer');
    if (newDrawer) drawer.innerHTML = newDrawer.innerHTML;
  }

  document.addEventListener('submit', async function (event) {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;

    event.preventDefault();
    const formData = new FormData(form);

    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    });

    if (!addResponse.ok) {
      form.submit();
      return;
    }

    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    updateCount(cart.item_count);

    await refreshDrawer();
    openDrawer();
  });
})();
